export default __webpack_public_path__ + "static/media/cp-logo.b744f2fe.svg";